import React, { ReactElement } from "react";
import styled from "styled-components";
import { FieldProps } from "formik";

interface InputBaseProps extends FieldProps {
    placeholder?: string;
    as?: any; // можно подставить MaskedInput
}

export const BaseInput: React.FC<InputBaseProps> = ({
    field,
    form,
    placeholder,
    as,
    ...rest
}): ReactElement => {

    const error = (form.errors as any)?.[field.name];
    const touched = (form.touched as any)?.[field.name];
    const hasError = Boolean(error && touched);

    return (
        <Wrapper>
            <StyledInput
                as={as}
                {...field}
                {...rest}
                placeholder={placeholder}
                $hasError={hasError}
                name={field.name}
                id={field.name}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    margin-bottom: 12px;
`;

export const StyledInput = styled.input<{ $hasError?: boolean }>`
    width: 100%;
    opacity: 0.5;
    height: 54px;
    background: none;
    border-radius: 16px;
    border: 1px solid ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#E46DD6")};
    padding-left: 25px;
    font-family: "Manrope";
    font-size: 16px;
    color: rgba(254, 255, 255, 0.7);

    &:focus {
        outline: none;
        border-color: ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#ff8be4")};
    }

    @media (min-width: 768px) {
        height: 64px;
        font-size: 22px;
    }
`;

const ErrorText = styled.div`
    margin-top: 4px;
    font-size: 12px;
    color: #ff4b4b;
`;
